import { userApi } from 'apiClient';
import { MATCH_USER_TO_SUPPLIER, SET_USERS, SET_USERS_FAILED } from '@/store/mutationTypes';
import ApiLoadingStatus from '@/api/statusTypes';
import { GET_USER_ACTION } from '@/store/actionTypes';

export default {
  state: { all: [], status: null },
  mutations: {
    [SET_USERS](state, users) {
      state.all = users || [];
      state.status = ApiLoadingStatus.STATUS_SUCCESSFUL;
    },
    [SET_USERS_FAILED](state) {
      state.all = [];
      state.status = ApiLoadingStatus.STATUS_ERROR_LOADING;
    },
    [MATCH_USER_TO_SUPPLIER](state, { selectedUser, selectedSupplier }) {
      if (!selectedUser || !selectedSupplier) return;
      let user = state.all.find((user) => user.id === selectedUser.id);
      if (user) user.creditorId = selectedSupplier.id;
    },
  },
  actions: {
    async [GET_USER_ACTION]({ commit }) {
      try {
        let users = await userApi.getUsers();
        commit(SET_USERS, users);
      } catch (e) {
        commit(SET_USERS_FAILED);
      }
    },
  },
  getters: {
    allUsers: (state) => {
      return state.all;
    },
    externalUsers: (state) => {
      return state.all.filter((user) => !user.email.toLowerCase().includes('@chronext'));
    },
    internalUsers: (state) => {
      return state.all.filter((user) => user.email.toLowerCase().includes('@chronext'));
    },
    byCreditorId: (state) => {
      return (creditorId) => {
        let users = state.all.filter((user) => user.creditorId === creditorId);
        return users[0] || null;
      };
    },
    userByEmail: (state, email) => {
      return state.all.filter((user) => user.email === email);
    },
    userById: (state, id) => {
      return state.all.filter((user) => user.id === id);
    },
  },
};
